export { ColorFacetTerms } from './ColorFacetTerms';
